import Api from "./Api";

export default {
  addDevice(params) {
    return Api().post(`/devices`, params.params);
  }
};
